import { AxiosError } from 'axios'
import * as SentryVue from '@sentry/vue'

const normalizeUrl = url =>
	(url ?? '')
		.split('?')[0]
		.replace(/\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\/|$)/gi, '/{uuid}')
		.replace(/\/\d+(?=\/|$)/g, '/{id}')

export const isAxiosTimeoutError = error =>
	error?.code === AxiosError.ETIMEDOUT || (error?.code === AxiosError.ECONNABORTED && /timeout/i.test(error?.message ?? ''))

const SERVER_TIMEOUT_STATUSES = [408, 504]

export const isServerTimeoutStatus = status => SERVER_TIMEOUT_STATUSES.includes(status)

export const reportRequestTimeout = ({ client, method, url, params = null, timeout = null, status = null }) => {
	const httpMethod = (method ?? '').toUpperCase()
	const route = normalizeUrl(url)
	const label = status ? `Request timeout (${status})` : 'Request timeout'
	SentryVue.captureMessage(`${label}: ${httpMethod} ${route}`, {
		level: 'warning',
		fingerprint: ['request-timeout', status != null ? String(status) : 'client', httpMethod, route],
		tags: {
			'request.timeout': true,
			'request.client': client,
			'request.method': httpMethod,
			'request.route': route,
			'request.status': status
		},
		contexts: {
			request_timeout: {
				url: url,
				params: params,
				timeout_ms: timeout
			}
		}
	})
}
